import { createFileRoute, redirect } from "@tanstack/react-router";

// Old WordPress media/attachment page — 301 to the German front page.
export const Route = createFileRoute("/de/mi-support-logo")({
  beforeLoad: () => {
    throw redirect({ to: "/de", statusCode: 301 });
  },
});
